import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { UserX, ArrowLeft } from 'lucide-react';

export function ImpersonationBanner() {
  const { isImpersonating, impersonator, user, exitImpersonation } = useAuth();

  if (!isImpersonating || !impersonator) {
    return null;
  }

  const handleExitImpersonation = async () => {
    await exitImpersonation();
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <UserX className="h-4 w-4" />
          <span className="text-sm font-medium">
            Vous etes connecte en tant que{' '}
            <strong>{user?.fullname}</strong>
            {' '}(via {impersonator.username})
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleExitImpersonation}
          className="text-white hover:bg-amber-600 hover:text-white"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Revenir a mon compte
        </Button>
      </div>
    </div>
  );
}
